import { claimSublimitsPrepare } from '@flows/configs/dental/utils/claimSublimits'
import { underwritingStep } from '@flows/configs/dental/utils/navigation'
import type { StepConfigParams } from '@flows/configs/types'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'

import { claimSublimitInfoBox } from './dental_previous_coverage_breakdown'

const dental_previous_coverage_with_gap = (params: StepConfigParams, plaform: 'native' | 'web') => {
  const nextStep = underwritingStep(plaform)

  return {
    onPrepare: claimSublimitsPrepare(params, { withInsurer: true }),
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_dental:steps.dental_previous_coverage_breakdown.title',
        },
        size: 'h3',
      },
      {
        type: 'text',
        emphasis: 'default',
        containsHTML: true,
        color: 'grey500',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_dental:steps.dental_previous_reimbursement.description.gap',
          values: {
            insurer: {
              type: 'dynamicValue',
              path: params.helperFunctions.getTransientPath('insurer'),
            },
          },
        },
        style: 'body1',
      },
      claimSublimitInfoBox(params),
    ],
    subFlow: params.subFlow,
    nextStep,
  } as const satisfies AnyStepConfiguration
}

export default dental_previous_coverage_with_gap
